import { defineComponent as _defineComponent } from 'vue';
import Dropdown from 'primevue/dropdown';
import { reactive, ref } from 'vue';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import PlotService from '../../../Services/PlotService';
import { trans } from 'laravel-vue-i18n';
import { enumToDropdownOptions, processDataForm, } from '../../../Services/Utils';
import { SoilDepth, SoilType } from '../../../@types/Enums';
import InputNumber from '../../../Components/InputNumber.vue';
import Checkbox from 'primevue/checkbox';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
import { useRoute } from '../../../Plugins/ziggy';
import { useSpinner } from '../../../Plugins/spinner';
import { useAxios } from '../../../Plugins/axios';
import { useMitt } from '../../../Plugins/mitt';
import { DateTime } from 'luxon';
import DocumentsForm from '../../../Components/DocumentsForm.vue';
import RecordBasicInfo from '../RecordBasicInfo.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['update:modelValue', 'cancel', 'saved'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const plotService = new PlotService();
        const route = useRoute();
        const spinner = useSpinner();
        const axios = useAxios();
        const emitter = useMitt();
        const documentsForm = ref();
        const newDocuments = ref([]);
        const defaultDate = (props.data.date
            ? DateTime.fromISO(props.data.date, { zone: 'utc' })
            : DateTime.now()).toJSDate();
        const data = reactive({
            id: props.data.id,
            orchard_id: props.data.orchard?.id,
            plot_ids: [],
            description: props.data.description || '',
            date: defaultDate,
            depth: props.data.depth,
            type: props.data.type,
            calcareous: props.data.calcareous || false,
            skeletal: props.data.skeletal,
            clay: props.data.clay,
            silt: props.data.silt,
            nitrate: props.data.nitrate,
            ph: props.data.ph,
            active_limestone: props.data.active_limestone,
            electrical_conductivity: props.data.electrical_conductivity,
            chloride: props.data.chloride,
            sulfate: props.data.sulfate,
            exchangeable_sodium: props.data.exchangeable_sodium,
            organic_matter: props.data.organic_matter,
            total_nitrogen: props.data.total_nitrogen,
            assimilable_phosphorus: props.data.assimilable_phosphorus,
            exchangeable_potassium: props.data.exchangeable_potassium,
            exchangeable_calcium: props.data.exchangeable_calcium,
            exchangeable_magnesium: props.data.exchangeable_magnesium,
            soluble_boron: props.data.soluble_boron,
            assimilable_iron: props.data.assimilable_iron,
            assimilable_manganese: props.data.assimilable_manganese,
            assimilable_copper: props.data.assimilable_copper,
            assimilable_zinc: props.data.assimilable_zinc,
            csc: props.data.csc,
        });
        const rules = {
            orchard_id: { required },
            plot_ids: { required },
            description: { required },
            date: { required },
            depth: { required },
            type: { required },
            calcareous: {},
            skeletal: {},
            clay: {},
            silt: {},
            nitrate: {},
            ph: {},
            active_limestone: {},
            electrical_conductivity: {},
            chloride: {},
            sulfate: {},
            exchangeable_sodium: {},
            organic_matter: {},
            total_nitrogen: {},
            assimilable_phosphorus: {},
            exchangeable_potassium: {},
            exchangeable_calcium: {},
            exchangeable_magnesium: {},
            soluble_boron: {},
            assimilable_iron: {},
            assimilable_manganese: {},
            assimilable_copper: {},
            assimilable_zinc: {},
            csc: {},
        };
        const v$ = useVuelidate(rules, data);
        const depthOptions = enumToDropdownOptions(SoilDepth, 'SoilDepth');
        const typeOptions = enumToDropdownOptions(SoilType, 'SoilType');
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            documentsForm.value.upload();
            const formData = processDataForm(data, newDocuments.value, props.data.documents);
            let url = data.id
                ? route('api.soil-data.update', [data.id])
                : route('api.soil-data.store');
            spinner.show();
            axios
                .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((res) => {
                emit('saved', res.data.data);
                emitter.emit('soil-data-saved', res.data.data);
            })
                .catch((err) => {
                console.log(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { plotService, route, spinner, axios, emitter, props, emit, documentsForm, newDocuments, defaultDate, data, rules, v$, depthOptions, typeOptions, save, get Dropdown() { return Dropdown; }, get trans() { return trans; }, InputNumber, get Checkbox() { return Checkbox; }, SaveCancelButtons, DocumentsForm, RecordBasicInfo };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
